// extracted by mini-css-extract-plugin
module.exports =  {"list":"List-module__list___PtKAN","display-mode-large":"List-module__display-mode-large___KzCTb"};